import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import { apiRequest } from "../../common/api/apiClient.js";
import type { AppDescriptorDTO } from "../../common/api/types.js";

export const appsQueryKey = ["apps"] as const;

/**
 * Die Apps, die dieser Benutzer öffnen darf. Die Liste kommt aus der App-Registry des
 * Backends (Issue #37) — der Header hat keine eigene, fest verdrahtete Liste.
 */
export function useApps(enabled: boolean): UseQueryResult<AppDescriptorDTO[], Error> {
  return useQuery({
    queryKey: appsQueryKey,
    queryFn: () => apiRequest<AppDescriptorDTO[]>("/apps"),
    enabled,
  });
}
